import React from 'react';
import { useTranslation } from 'react-i18next';
import Overview from 'Components/Overview';

type GenOverview = { id: string; label: string; data: string | number };

const genOverview = (
    apiData: GlobalRulesData,
    t: (s: String) => string,
    isLandlordDeployment: boolean
): GenOverview[] => [
    {
        id: 'rules',
        label: t('Rules'),
        data: apiData?.rules.length
    },
    {
        id: 'active',
        label: t('Active'),
        data: apiData?.rules?.filter((o) => o.parameters.active).length
    },
    {
        id: 'description',
        label: t('Description'),
        data: isLandlordDeployment ? t('Network rule set') : apiData?.config?.description || ''
    }
];

const DeployedGlobalRulesOverview = ({
    data,
    isLandlordDeployment
}: {
    data: GlobalRulesData;
    isLandlordDeployment: boolean;
}) => {
    const { t } = useTranslation();

    const overview = genOverview(data, t, isLandlordDeployment);
    const threshold = !isLandlordDeployment
        ? [
              {
                  label: t('Aggregate Scoring Threshold'),
                  data: data?.config?._formatted?.inputDescription || data?.config?._formatted?.description
              }
          ]
        : [];

    return (
        <>
            <Overview
                dataTestId='global-rules-overview'
                leftTitle={isLandlordDeployment ? t('Network Rules Overview') : t('Global Rules Overview')}
                leftData={overview}
                rightData={threshold}
            />
        </>
    );
};

export default DeployedGlobalRulesOverview;
